<template>
  <path
    d="M13 7.00018H11V9.00018H13V7.00018ZM12 11.0002C11.45 11.0002 11 11.4502 11 12.0002V16.0002C11 16.5502 11.45 17.0002 12 17.0002C12.55 17.0002 13 16.5502 13 16.0002V12.0002C13 11.4502 12.55 11.0002 12 11.0002ZM17 1.01018L7 1.00018C5.9 1.00018 5 1.90018 5 3.00018V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00018C19 1.90018 18.1 1.01018 17 1.01018ZM17 19.0002H7V5.00018H17V19.0002Z"
  />
</template>
